import { SortDirectionType } from '@core/types';
import { HttpParams } from '@angular/common/http';
import { ClassConstructor } from 'class-transformer';
import * as jwt_decode from 'jwt-decode';
import { Type } from '@angular/core';
import moment, {Moment} from 'moment/moment';

export const compare = (v1: string | number, v2: string | number) =>
  v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
export const rotate: { [key: string]: SortDirectionType } = { asc: 'desc', desc: '', '': 'asc' };

// export const paramsToBody = (params: HttpParams): string =>
//   JSON.stringify(params.keys().map(x => ({ [x]: params.get(x) })));

export const paramsToBody = (params: HttpParams): string => {
  let paramsJson: any = {};

  params.keys().forEach((key: string) => {
    paramsJson[key.toString()] = params.get(key);
  });

  return JSON.stringify(paramsJson);
};

export const checkInstance = (
  entries: { value: unknown; type: string; typeClass: ClassConstructor<any> }[]
): boolean => {
  let result = true;
  entries.forEach((entry) => {
    result =
      result &&
      (typeof entry.value === entry.type ||
        entry.value instanceof entry.typeClass ||
        entry.value == null);
  });
  return result;
};

export const createRequestParams = (obj: any): HttpParams => {
  let result: HttpParams = new HttpParams();

  Object.keys(obj).forEach((key: string) => {
    result = result.set(key, obj[key.toString()]);
  });

  return result;
};

export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const isLikeHTMLb64 = (b64: string): boolean => {
  try {
    const txt = atob(b64).slice(0, 50).toLowerCase();
    return txt.includes('<!doctype html') || txt.includes('<html');
  } catch {
    return false;
  }
};

export const decodeB64ToText = (b64: string): string => {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new TextDecoder('utf-8').decode(bytes);
};

export const b64ToBlob = (b64: string, mimeType: string): Blob => {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mimeType });
};

export const forceDownload = (url: string, filename: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const isString = (value: any) => {
  return typeof value === 'string';
};

export const decodeToken = (token: string): Object => {
  try {
    return jwt_decode.jwtDecode<string>(token);
  } catch (Error) {
    return new Object({});
  }
};

export const checkDate = (date: string, debug?: boolean): Moment => {
  if(debug) {
    console.log('Debug date = ' + date);
  }
  return moment(date, [
    'YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY.MM.DD',
    'DD-MM-YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY',
    'YYYY-M-D', 'YYYY/M/D', 'YYYY.M.D',
    'D-M-YYYY', 'D/M/YYYY', 'D.M.YYYY'], true);
}
